function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M57.587 0h-50.4C3.722 0 .918 2.869.918 6.375l-.031 38.25c0 3.506 2.835 6.375 6.3 6.375h50.4c3.465 0 6.3-2.869 6.3-6.375V6.375c0-3.506-2.835-6.375-6.3-6.375Zm0 44.625h-50.4V12.75l25.2 15.938 25.2-15.938v31.875Zm-25.2-22.312L7.187 6.375h50.4l-25.2 15.938Z",
    style: {
      fill: "currentColor"
    },
    transform: "translate(-.886)"
  }));
};
export default SvgMailIcon;